// Add at the bottom of theme.js.liquid
// Ensure DOM is fully loaded
//SUBSCRIPTION PAGE START----------------------------------------------------------------------------------------------
//Subscription buttons to navigate to optionDelivery Page with value
// document.addEventListener('DOMContentLoaded', function() {
//     // Define the target node to observe - in this case, it's likely the body
//     // or a more specific container known to be dynamically loaded by PageFly
//     var buttonsSetupDone = false;
//     var targetNode = document.body;

//     // Options for the observer (which mutations to observe)
//     var config = { childList: true, subtree: true };

//     // Callback function to execute when mutations are observed
//     var callback = function(mutationsList, observer) {
//         // Check if any of the mutations added nodes
//         for(var mutation of mutationsList) {
//             if (mutation.addedNodes.length) {
//                 // Attempt to set up your button listeners
//                 setupButtonListener('sub4buttonId', 1);
//                 setupButtonListener('sub6button', 2);
//                 setupButtonListener('sub12button', 3);
//                 setupButtonListener('subCustomButton', 4);
//                 setupButtonListener('one4button', 5);
//                 setupButtonListener('one6button', 6);
//                 setupButtonListener('one12button', 7);
//                 setupButtonListener('oneCustomButton', 8);

//                 // Optionally, stop observing after setting up the listeners
//                 observer.disconnect();
//                 break;
//             }
//         }
//     };

//     // Create an observer instance linked to the callback function
//     var observer = new MutationObserver(callback);

//     // Start observing the target node for configured mutations
//     observer.observe(targetNode, config);
// });

// function setupButtonListener(buttonId, intValue) {
//     var button = document.getElementById(buttonId);
//     if (button) {
//         button.addEventListener('click', function(event) {
//             event.preventDefault(); // Prevent the default action
//             var nextPageUrl = '/pages/optiondelivery?intValue=' + encodeURIComponent(intValue);

//           // Specific URL for sub4buttonId
//             if (buttonId === 'sub4button') {
//                 nextPageUrl = 'pages/4-meals-plan-option-delivery';
//             }
//           if (buttonId === 'sub4buttonId') {
//                 nextPageUrl = 'https://eatfyb.ca/pages/4-meals-plan-option-delivery';
//             }
//             console.log("Navigating to: " + nextPageUrl);

//             window.location.href = nextPageUrl; // Navigate with the added parameter
//         });
//     }
// }

//SUBSCRIPTION PAGE END----------------------------------------------------------------------------------------------

//OPTION DELIERY PAGE START----------------------------------------------------------------------------------------------
//dynamic map and dropdown options
// document.addEventListener('DOMContentLoaded', function() {
//   // var inputField = document.getElementById('optionalDeliveryInputField');
//   var selectField = document.getElementById('optionalDeliverySelectField'); // Updated to target select field
//   var optionsContainer = document.getElementById('deliveryOptionsContainer');
//   // Hide options container when the page loads
//     optionsContainer.style.display = 'none';

//   // disable inputField ( per request)
//   // if (inputField) {
//   //   inputField.addEventListener('input', function() {
//   //     var postalCode = inputField.value;
//   //     // Call your function with the current input value
//   //     if (postalCode.length >= 3) {
//   //   checkPostalCodeForOptionDelivery(postalCode);
//   // } else {
//   //   updateDeliveryOptionUI("hide"); // Hide options if less than 3 digits are entered
//   // }
//   //   });
//   // }
//   //enable dropdown
//   if (selectField) {
//     selectField.addEventListener('change', function() {
//       var selectedValue = selectField.value;
//       // Call your function with the current selected value
//       if (selectedValue) {
//         checkPostalCodeForOptionDelivery(selectedValue);
//       } else {
//         updateDeliveryOptionUI("hide"); // Hide options if no option is selected
//       }
//     });
//   }
// });
//use below method to load elementById
document.addEventListener("DOMContentLoaded", function () {
  let checkElementsInterval = setInterval(function () {
    var selectField = document.getElementById("optionalDeliverySelectField");
    var optionsContainer = document.getElementById("deliveryOptionsContainer");

    if (selectField && optionsContainer) {
      // Both elements exist, can now add event listener and hide the options container
      clearInterval(checkElementsInterval); // Stop checking now that we've found the elements

      // Hide options container now that it's definitely in the DOM
      optionsContainer.style.display = "none";

      selectField.addEventListener("change", function () {
        var selectedValue = selectField.value;
        // Call your function with the current selected value
        if (selectedValue) {
          checkPostalCodeForOptionDelivery(selectedValue);
        } else {
          updateDeliveryOptionUI("hide"); // Hide options if no option is selected
        }
      });
    }
  }, 100); // Check every 100 milliseconds
});

function checkPostalCodeForOptionDelivery(postalCode) {
  // Arrays representing different options
  var optionOneArray = ["CHARLOTTETOWN"];
  var optionTwoArray = ["STRATFORD"];
  var optionThreeArray = ["SUMMERSIDE"];
  var optionFourArray = ["CORNWALL"];
  var optionFiveArray = ["KENSINGTON"];
  var optionSixArray = ["MONTAGUE"];

  // var optionOneArray = ['M2N', 'L2G', 'M3J'];
  // var optionTwoArray = ['K1A', 'K2B', 'L3C'];
  // var optionThreeArray = ['N1M', 'N2N', 'L4L'];

  // Check which array the postalCode matches
  var matchFound = false;
  // if (optionOneArray.includes(postalCode.toUpperCase())) {
  //   updateDeliveryOptionUI("one");
  //   matchFound = true;
  // } else if (optionTwoArray.includes(postalCode.toUpperCase())) {
  //   updateDeliveryOptionUI("two");
  //   matchFound = true;
  // } else if (optionThreeArray.includes(postalCode.toUpperCase())) {
  //   updateDeliveryOptionUI("three");
  //   matchFound = true;
  // }

  if (optionOneArray.includes(postalCode.toUpperCase())) {
    updateDeliveryOptionUI("CHARLOTTETOWN");
    matchFound = true;
  } else if (optionTwoArray.includes(postalCode.toUpperCase())) {
    updateDeliveryOptionUI("STRATFORD");
    matchFound = true;
  } else if (optionThreeArray.includes(postalCode.toUpperCase())) {
    updateDeliveryOptionUI("SUMMERSIDE");
    matchFound = true;
  } else if (optionFourArray.includes(postalCode.toUpperCase())) {
    updateDeliveryOptionUI("CORNWALL");
    matchFound = true;
  } else if (optionFiveArray.includes(postalCode.toUpperCase())) {
    updateDeliveryOptionUI("KENSINGTON");
    matchFound = true;
  } else if (optionSixArray.includes(postalCode.toUpperCase())) {
    updateDeliveryOptionUI("MONTAGUE");
    matchFound = true;
  }

  // If no match is found
  if (!matchFound) {
    updateDeliveryOptionUI("none");
  }
}

// Function to update the UI based on the match
// Function to update the UI based on the match
function updateDeliveryOptionUI(option) {
  var messageElement = document.getElementById("deliveryStatusMessage");
  var optionsContainer = document.getElementById("deliveryOptionsContainer");
  var imgElement = document.getElementById("deliveryOptionImage");

  // Hide options initially
  optionsContainer.style.display = "none";

  // var imgSrc = {
  //   'one': 'https://cdn.shopify.com/s/files/1/0279/9085/1715/files/summerside.jpg', // Example image for option one
  //   'two': 'https://cdn.shopify.com/s/files/1/0279/9085/1715/files/summerside.jpg', // Example image for option two
  //   'three': 'https://cdn.shopify.com/s/files/1/0279/9085/1715/files/summerside.jpg', // Example image for option three
  //   'none': 'https://cdn.shopify.com/s/files/1/0279/9085/1715/files/entire_city.jpg', // Image when no delivery options are available
  //   'hide': 'https://cdn.shopify.com/s/files/1/0279/9085/1715/files/entire_city.jpg' // Default image
  // };
  var imgSrc = {
    CHARLOTTETOWN:
      "https://cdn.shopify.com/s/files/1/0279/9085/1715/files/charlottetown.jpg", // Example image for option one
    STRATFORD:
      "https://cdn.shopify.com/s/files/1/0279/9085/1715/files/stratford.jpg", // Example image for option two
    SUMMERSIDE:
      "https://cdn.shopify.com/s/files/1/0279/9085/1715/files/summerside.jpg", // Example image for option three
    CORNWALL:
      "https://cdn.shopify.com/s/files/1/0279/9085/1715/files/cornwall.jpg",
    KENSINGTON:
      "https://cdn.shopify.com/s/files/1/0279/9085/1715/files/kensington.jpg",
    MONTAGUE:
      "https://cdn.shopify.com/s/files/1/0279/9085/1715/files/montague.jpg", // Image when no delivery options are available
    none: "https://cdn.shopify.com/s/files/1/0279/9085/1715/files/charlottetown.jpg",
    hide: "https://cdn.shopify.com/s/files/1/0279/9085/1715/files/charlottetown.jpg", // Default image
  };

  switch (option) {
    case "CHARLOTTETOWN":
      messageElement.textContent =
        "The full list of pick-up locations will be shown at the checkout.";
      optionsContainer.style.display = ""; // Show options
      imgElement.src = imgSrc.CHARLOTTETOWN;
      // Ensure the second delivery option is visible (in case it was previously hidden)
      document.querySelector(
        "#deliveryOptionsContainer .option:nth-child(2)"
      ).style.display = "";
      break;

    case "STRATFORD":
      messageElement.textContent =
        "The full list of pick-up locations will be shown at the checkout.";
      optionsContainer.style.display = ""; // Show options
      imgElement.src = imgSrc.STRATFORD;
      // Ensure the second delivery option is visible (in case it was previously hidden)
      document.querySelector(
        "#deliveryOptionsContainer .option:nth-child(2)"
      ).style.display = "";
      break;

    case "SUMMERSIDE":
      messageElement.textContent =
        "The full list of pick-up locations will be shown at the checkout.";
      optionsContainer.style.display = ""; // Show options
      imgElement.src = imgSrc.SUMMERSIDE;
      // Ensure the second delivery option is visible (in case it was previously hidden)
      document.querySelector(
        "#deliveryOptionsContainer .option:nth-child(2)"
      ).style.display = "";
      break;

    case "CORNWALL":
      messageElement.textContent =
        "The full list of pick-up locations will be shown at the checkout.";
      optionsContainer.style.display = ""; // Show options
      imgElement.src = imgSrc.CORNWALL;
      // Ensure the second delivery option is visible (in case it was previously hidden)
      document.querySelector(
        "#deliveryOptionsContainer .option:nth-child(2)"
      ).style.display = "";
      break;

    case "KENSINGTON":
      messageElement.textContent =
        "The full list of pick-up locations will be shown at the checkout.";
      optionsContainer.style.display = ""; // Show options
      imgElement.src = imgSrc.KENSINGTON;
      // Hide the second delivery option
      document.querySelector(
        "#deliveryOptionsContainer .option:nth-child(2)"
      ).style.display = "none";
      break;

    case "MONTAGUE":
      messageElement.textContent =
        "The full list of pick-up locations will be shown at the checkout.";
      optionsContainer.style.display = ""; // Show options
      imgElement.src = imgSrc.MONTAGUE;
      // Ensure the second delivery option is visible (in case it was previously hidden)
      document.querySelector(
        "#deliveryOptionsContainer .option:nth-child(2)"
      ).style.display = "";
      break;

    case "none":
      messageElement.textContent =
        "No delivery options available for your area.";
      imgElement.src = imgSrc.none;
      break;

    case "hide":
      // This case is used when the input is less than 3 characters
      messageElement.textContent =
        "The full list of pick-up locations will be shown at the checkout."; // Enter your postal code to see options.
      imgElement.src = imgSrc.hide;
      break;

    default:
      imgElement.src = imgSrc.hide;
      break;
  }
}

//Action Button to navigate to designated bundle based on option selection and sub option int data passed from previous page
// document.getElementById('optionalDeliverySelectField').addEventListener('change', function() {
//   // Show the action button regardless of the selection
//   document.querySelector('.option-delivery .action-button button').style.display = 'block'; // Ensures the button is always shown
// });

document.addEventListener("DOMContentLoaded", function () {
  setupNavigation();
});

// function setupNavigation(passedValue) {
//     const navigateButton = document.getElementById('chooseYourMealOptionDeliveryButton');
//     navigateButton.addEventListener('click', function() {
//         const selectedOption = document.querySelector('input[name="deliveryOption"]:checked');
//         if (selectedOption) {
//             const selectedOptionValue = selectedOption.value;
//             // Determine the target URL based on both passedValue and selectedOptionValue
//             const targetUrl = determineTargetUrl(passedValue, selectedOptionValue);
//             window.location.href = targetUrl;
//         } else {
//             alert('Please select a delivery option.');
//         }
//     });
// }
//use below method to prevent buttonId not loaded
function setupNavigation() {
  // Delay the execution of the setup code to wait for the button to load
  setTimeout(function () {
    setupButtonListener("chooseYourMealOptionDeliveryButton", 1);
    setupButtonListener("chooseYourSub6MealOptionDeliveryButton", 2);
    setupButtonListener("chooseYourSub12MealOptionDeliveryButton", 3);
    setupButtonListener("chooseYourSubCustomMealOptionDeliveryButton", 4);
    setupButtonListener("chooseYourOne4MealOptionDeliveryButton", 5);
    setupButtonListener("chooseYourOne6MealOptionDeliveryButton", 6);
    setupButtonListener("chooseYourOne12MealOptionDeliveryButton", 7);
    setupButtonListener("chooseYourOneCustomMealOptionDeliveryButton", 8);
  }, 3500); // Adjust the delay here as needed, 1000 milliseconds = 1 second
}

function setupButtonListener(buttonId, passedValue) {
  const button = document.getElementById(buttonId);
  console.log(`Button with ID checking "${buttonId}" and "${passedValue}"`);
  if (button) {
    button.addEventListener("click", function () {
      const selectedOption = document.querySelector(
        'input[name="deliveryOption"]:checked'
      );
      if (selectedOption) {
        const selectedOptionValue = selectedOption.value;
        // Determine the target URL based on both passedValue and selectedOptionValue
        const targetUrl = determineTargetUrl(passedValue, selectedOptionValue);
        window.location.href = targetUrl;
      } else {
        alert("Please select a delivery option.");
      }
    });
  } else {
    console.log(
      `Button with ID "${buttonId}" not found, check if the ID is correct or increase the setTimeout duration`
    );
  }
}

function determineTargetUrl(passedValue, selectedOptionValue) {
  // Map of all possible combinations of passedValue and selectedOptionValue to their respective URLs
  const urlMap = {
    "1_Delivery once a week":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/7a495569bf114c17ab6c0990c3fd7caf",
    "1_Store pick up":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/7a495569bf114c17ab6c0990c3fd7caf",
    "2_Delivery once a week":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/1e942ca58afd43b8a4659100e1f927eb",
    "2_Store pick up":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/1e942ca58afd43b8a4659100e1f927eb",
    "3_Delivery once a week":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/65612cd138c5466e847171dc2445c863",
    "3_Store pick up":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/65612cd138c5466e847171dc2445c863",
    "4_Delivery once a week":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/7684e2865c4b47e1ab938fec6073ad54",
    "4_Store pick up":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/7684e2865c4b47e1ab938fec6073ad54",

    "5_Delivery once a week":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/cc2ae0eac9784495a2c6dc1387e0126d",
    "5_Store pick up":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/cc2ae0eac9784495a2c6dc1387e0126d",
    "6_Delivery once a week":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/895d6cda25424cd0ad7af799be047888",
    "6_Store pick up":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/895d6cda25424cd0ad7af799be047888",
    "7_Delivery once a week":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/c70b2620d9e243448046a7c124bbd2c2",
    "7_Store pick up":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/c70b2620d9e243448046a7c124bbd2c2",
    "8_Delivery once a week":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/a16226f5a9e941eb842bdf151f1bb111",
    "8_Store pick up":
      "https://fuel-your-body-healthy-meal-delivery.myshopify.com/a/loop_subscriptions/bundle/a16226f5a9e941eb842bdf151f1bb111",
  };

  // Creating a key from passedValue and selectedOptionValue to fetch the corresponding URL
  const key = `${passedValue}_${selectedOptionValue}`;
  console.log(`key checking "${key}"`);

  // Fetching the URL using the key; defaults to '/' if the key doesn't exist in the map
  return urlMap[key] || "https://eatfyb.ca/pages/plans";
  // For a real application, this function would need to map to actual URLs based on your app's routing.
}

//make option container clickable
document.addEventListener("DOMContentLoaded", function () {
  // Select all .option elements within the #deliveryOptionsContainer
  var options = document.querySelectorAll("#deliveryOptionsContainer .option");

  // Add a click event listener to each option
  options.forEach(function (option) {
    option.addEventListener("click", function () {
      // Find the input[type="radio"] element within the clicked .option and check it
      var radioButton = this.querySelector('input[type="radio"]');
      if (radioButton) {
        radioButton.checked = true;
      }
    });
  });
});

//OPTION DELIERY PAGE END----------------------------------------------------------------------------------------------

/// /DYNAMIC MENU PAGE START ----------------------------------------------------------------------------------------------
// Function to calculate next delivery date with Thursday 1 PM PEI cutoff
function calculateNextMonday() {
  const today = new Date();
  
  // Get PEI time (America/Halifax timezone)
  const peiDate = new Date(today.toLocaleString('en-US', { timeZone: 'America/Halifax' }));
  const currentHour = peiDate.getHours();
  const currentDay = peiDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  
  let daysUntilNextMonday;
  
  // After Thursday 1PM or Friday/Saturday, schedule for Monday after next
  if ((currentDay === 4 && currentHour >= 13) || currentDay > 4) {
    daysUntilNextMonday = (8 - currentDay) + 7;
  } else {
    // Monday to Thursday (before 1PM) and Sunday: schedule for the immediate next Monday
    daysUntilNextMonday = (8 - currentDay);
  }
  
  const nextMonday = new Date(peiDate);
  nextMonday.setDate(peiDate.getDate() + daysUntilNextMonday);
  nextMonday.setHours(12, 0, 0, 0);
  
  return nextMonday;
}

// Update delivery date on standard page
document.addEventListener("DOMContentLoaded", function () {
  const nextMonday = calculateNextMonday();
  const options = { 
    month: "long", 
    day: "numeric", 
    timeZone: "America/Halifax" 
  };

  const nextMondayString = nextMonday.toLocaleDateString("en-US", options);

  const deliveryDateElement = document.getElementById("next-delivery-date");
  if (deliveryDateElement) {
    deliveryDateElement.textContent = "Next Delivery Date: Monday " + nextMondayString;
  }
});

// Update delivery date on bundle pages after a short delay
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    if (window.location.href.includes("loop_subscriptions/bundle")) {
      var pElements = document.querySelectorAll("p");
      pElements.forEach(function (p) {
        if (p.textContent.includes("NEXT DELIVERY DATE:")) {
          var nextMonday = calculateNextMonday();
          var options = {
            month: "long",
            day: "numeric",
            timeZone: "America/Halifax"
          };
          var nextMondayString = nextMonday.toLocaleDateString("en-US", options);

          p.innerHTML =
            "NEXT DELIVERY DATE: MONDAY " +
            nextMondayString.toUpperCase() +
            "<br><span>VEGETABLES MAY VARY FROM PICTURES</span>";
        }
      });
    }
  }, 3000);
});


//filter buttons to filter different tags
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".custom_filter-button");
  const products = document.querySelectorAll(".custom_menu_product-card");

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const filter = this.getAttribute("data-filter");

      // Update active button
      buttons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      // Filter products
      products.forEach((product) => {
        const tags = product.getAttribute("data-tags");
        if (filter === "all" || tags.includes(filter)) {
          product.style.display = "";
        } else {
          product.style.display = "none";
        }
      });
    });
  });
});

//DYNAMIC MENU PAGE END ----------------------------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  function hideButtons() {
    // Check if the URL contains 'products'
    if (
      window.location.href.includes("/products/") &&
      !window.location.href.includes("/products/gift-card")
    ) {
      // Hide the "Add to Cart" button
      var addToCartButtons = document.querySelectorAll(".add-to-cart");
      addToCartButtons.forEach(function (button) {
        button.style.display = "none";
      });

      // Try to hide the "Buy It Now" button using a more general selector or by targeting the parent container
      var buyItNowButtons = document.querySelectorAll(
        '[name="add"], .shopify-payment-button, .shopify-payment-button__button--unbranded'
      );
      buyItNowButtons.forEach(function (button) {
        button.style.display = "none";
      });
    }
  }

  // Run immediately
  hideButtons();

  // Polling to catch dynamically loaded buttons
  var attempt = 0;
  var interval = setInterval(function () {
    hideButtons();
    attempt++;

    // Stop after 10 attempts to avoid infinite running
    if (attempt > 10) {
      clearInterval(interval);
    }
  }, 1000); // Check every second
});

//HOMEPAGE DYNAMIC MENU SECTION START ----------------------------------------------------------------------------------------------

//map product title and images to the menu section
document.addEventListener("DOMContentLoaded", function () {
  // A function to check for DST adjustment
  // function isDST(date) {
  //     let jan = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
  //     let jul = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
  //     return Math.max(jan, jul) !== date.getTimezoneOffset();
  // }

  const observer = new MutationObserver((mutations, obs) => {
    const imageElement = document.getElementById("home_upcoming_img7"); // Ensure this matches the first image element's ID
    if (imageElement) {
      obs.disconnect(); // Stop observing once we have our element
      fetchAndUpdateUI(); // Call your function to update the UI
    }
  });

  observer.observe(document, { childList: true, subtree: true });

  function fetchAndUpdateUI() {
    // Define the start date (March 28, 2024) and calculate the current week number since then
    // const startDate = new Date('2024-03-28');
    const estOffset = 5 * 60 * 60 * 1000; // 5 hours in milliseconds
    const startDate = new Date(Date.UTC(2024, 2, 28, 15));

    const today = new Date();
    const millisecondsPerWeek = 604800000;
    let weeksSinceStart = Math.floor((today - startDate) / millisecondsPerWeek);

    // Define the collection handles in the order they should be displayed
    const collectionHandles = [
      "menu-d",
      "menu-aa",
      "menu-bb",
      "menu-cc",
      "menu-dd",
      "menu-a",
      "menu-b",
      "menu-c",
    ];
    // Determine the collection handle to use based on the current week number
    const collectionHandle =
      collectionHandles[weeksSinceStart % collectionHandles.length];
    console.log(`Current Collection Handle: ${collectionHandle}`);

    // Fetch products from the collection
    fetch(`/collections/${collectionHandle}/products.json`)
      .then((response) => response.json())
      .then((data) => {
        // const products = data.products.sort((a, b) => a.title.localeCompare(b.title));
        updateUIWithProducts(data.products);
      })
      .catch((error) => console.error("Error fetching products:", error));
  }
});

function updateUIWithProducts(products) {
  // Assuming you want to update the first 10 products
  products.slice(0, 10).forEach((product, index) => {
    // Correctly interpolate index in the ID strings
    const imageElement = document.getElementById(
      `home_upcoming_img${index + 1}`
    );
    const titleElement = document.getElementById(
      `home_upcoming_title${index + 1}`
    );

    // Debugging: Log to see if elements are found
    console.log(
      `Looking for image: home_upcoming_img${index + 1}`,
      imageElement
    );
    console.log(`Product #${index + 1} name:`, product.title);

    if (imageElement && titleElement) {
      imageElement.src = product.images[0].src;
      titleElement.textContent = product.title;

      // Otherwise, if the ID is on the container, this will directly set the background color.
      const containerElement = imageElement.parentElement || imageElement;
      containerElement.style.backgroundColor = "white";
    } else {
      console.error("Element not found for index:", index + 1);
    }
  });
}

//HOMEPAGE DYNAMIC MENU SECTION END ----------------------------------------------------------------------------------------------

//PageFLY might impact observ
